import { render, staticRenderFns } from "./VgButton.vue?vue&type=template&id=24fcd482&scoped=true&"
import script from "./VgButton.vue?vue&type=script&lang=js&"
export * from "./VgButton.vue?vue&type=script&lang=js&"
import style0 from "./VgButton.vue?vue&type=style&index=0&id=24fcd482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fcd482",
  null
  
)

export default component.exports